{
    "login": {
        "title": "Iniciar sesión",
        "email": "Email",
        "identifier": "Correo o teléfono",
        "identifierInvalid": "Ingresa un correo o teléfono válido",
        "password": "Contraseña",
        "submit": "Ingresar",
        "forgotPassword": "Olvidé mi contraseña"
    },
    "newPassword": {
        "title": "Crear nueva contraseña",
        "newPassword": "Nueva contraseña",
        "confirmPassword": "Confirmar contraseña",
        "submit": "Guardar",
        "mismatch": "Las contraseñas no coinciden"
    },
    "mfa": {
        "chooseMethod": "Elige un método MFA",
        "totp": "Autenticador",
        "email": "Email",
        "totpWizard": {
            "title": "Configurar autenticador",
            "scanQr": "Escanea el código QR con tu app",
            "enterCode": "Ingresa el código de 6 dígitos",
            "verify": "Verificar"
        },
        "emailWizard": {
            "title": "Configurar Email MFA",
            "requestCode": "Solicitar código",
            "enterCode": "Código recibido por email",
            "verify": "Verificar"
        },
        "challenge": {
            "title": "Código MFA",
            "totpPlaceholder": "Código del autenticador",
            "emailPlaceholder": "Código recibido por email",
            "submit": "Continuar"
        }
    },
    "forgotPassword": {
        "request": {
            "title": "Recuperar contraseña",
            "subtitle": "Te enviaremos un código para restablecer tu contraseña.",
            "submit": "Enviar código",
            "generic": "Si el email está registrado, recibirás un código por correo."
        },
        "pick": {
            "prompt": "Tu correo está asociado a varias cuentas. ¿De qué cuenta quieres recuperar la contraseña?",
            "changeEmail": "Cambiar correo"
        },
        "verifyOtp": {
            "title": "Verifica el código",
            "subtitle": "Te enviamos un código a {{email}}. Vence en 2 minutos.",
            "code": "Código",
            "submit": "Validar código",
            "resend": "Reenviar código",
            "resent": "Te reenviamos el código",
            "invalid": "Código inválido o expirado",
            "resendIn": "Puedes pedir un código nuevo en {{time}}",
            "noCode": "¿No te llegó el código?"
        },
        "setPassword": {
            "title": "Crea tu nueva contraseña",
            "subtitle": "Tu código fue verificado. Ahora elige una contraseña nueva.",
            "newPassword": "Nueva contraseña",
            "confirmPassword": "Confirmar nueva contraseña",
            "submit": "Restablecer",
            "success": "Contraseña restablecida"
        },
        "backToLogin": "Volver al inicio de sesión"
    },
    "activating": "Activando cuenta…",
    "errors": {
        "invalidCredentials": "Email o contraseña incorrectos"
    }
}
